import React from 'react';
import { CardHeader, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Player } from '../../../state/reduxRepositories/players/player.interfaces';
import { getInitials } from '../../../helpers/initialsExtractor';
import { dateTime } from '../../../time/datetime';
import { Avatar } from '../../../components/avatar/avatar';

interface ConneqtedPlayerProps {
  player?: Player;
}

export const ConneqtedPlayer = ({ player }: ConneqtedPlayerProps) => {
  const { t } = useTranslation();
  return (
    <CardHeader
      avatar={
        <Avatar
          title={getInitials(`${player?.firstName} ${player?.lastName}`)}
        />
      }
      title={`${player?.firstName} ${player?.lastName}`}
      titleTypographyProps={{ variant: 'subtitle2' }}
      subheaderTypographyProps={{ variant: 'subtitle2' }}
      subheader={
        <Typography variant="subtitle2">
          {dateTime.format(
            player?.dateOfBirth,
            t('common.datetime.FORMAT_SHORT_DATE'),
          )}
        </Typography>
      }
      sx={{ p: 0 }}
    />
  );
};
